import { useInviteNavigation } from '../../hooks/useInviteNavigation';
import { VerifyPhoneFormBase } from './VerifyPhoneFormBase';

export const InviteVerifyPhoneForm = () => {
  const { goToNextStep, goToPreviousStep, currentStepIndex, totalSteps } = useInviteNavigation();

  return (
    <VerifyPhoneFormBase
      goToNextStep={goToNextStep}
      goToPreviousStep={goToPreviousStep}
      currentStep={currentStepIndex + 1}
      totalSteps={totalSteps}
    />
  );
};
